// Libraries
import React from 'react'

// Layouts
import { MainWrapperWithCaptions } from '../../layouts/MainWrapperWithCaptions'
import { LowerArrow, UpperArrow } from '../../layouts/Arrows'
import { Books } from '../../layouts/Books'

// Styles
import {
  CaptionFantomMobile,
  Column, DirtyButton,
  FakeRow,
  TextOutlined, TitleDesktopFantom,
  TitleInitialPage
} from '../../layouts/MainWrapperWithCaptions/style'
import { VerticalLineFantom } from '../../style'

interface IProps {
  setStageAndToTop: (arg0: number) => void;
}

export const InitialPage = ({ setStageAndToTop }: IProps) => {

  return (
      <>
        <MainWrapperWithCaptions key={0}>
          <FakeRow>
            <Column>
              <TextOutlined>99</TextOutlined>
              <CaptionFantomMobile>Tipps</CaptionFantomMobile>
            </Column>
            <VerticalLineFantom />
            <TitleInitialPage>für den perfekten <br/> Charterurlaub</TitleInitialPage>
            <TitleDesktopFantom>Tipps für den perfekten Charterurlaub</TitleDesktopFantom>
          </FakeRow>
        </MainWrapperWithCaptions>
        <Books />
        <Column>
          <UpperArrow src="/UpperArrow.svg" initial={{ y: 0, opacity: .8 }}
                      animate={{ y: 5, opacity: 1 }}
                      exit={{ x: 20, opacity: 0 }}
                      transition={{ duration: 0.5, repeat: Infinity, repeatType: 'mirror' }}/>
          <LowerArrow src='/LowerArrow.svg' initial={{ y: 0, opacity: .8 }}
                      animate={{ y: 7, opacity: 1 }}
                      exit={{ x: 20, opacity: 0 }}
                      transition={{ duration: 0.5, repeat: Infinity, repeatType: 'mirror' }}/>
          <DirtyButton onClick={() => setStageAndToTop(1)}>
            Jetzt kostenlos downloaden
          </DirtyButton>
        </Column>
      </>
    )
}
